import {
  Grid,
  GridCol,
  GridRow,
  SiteFooterV2,
  SiteFooterV2Item,
  SiteFooterV2ItemGroup,
  SiteFooterV2Main,
  SiteFooterV2Utility,
  Text,
  VerticalSpace,
  Group,
  GroupItem,
  ButtonV2,
} from '@arc-ui/components';
import { FooterComponentProps } from '../../../types/ee-footer';

const EEBFooterDesktop = ({
  itemGroups,
  socialLinks,
  infoLinks,
  copyrightNotice,
  socialData,
}: FooterComponentProps): React.ReactElement => {
  return (
    <>
      <SiteFooterV2>
        <SiteFooterV2Main columns={4}>
          {itemGroups?.map((group) => (
            <SiteFooterV2ItemGroup key={group.title}>
              <Text size="s" id="ee-site-link-itemgroup">
                {group.title.replace(' - Test', '')}
              </Text>
              {group.linkListItems.map((item) => (
                <SiteFooterV2Item key={item.title} href={item.linkUrl}>
                  <Text size="s" id="ee-site-link-items">
                    {item.title}
                  </Text>
                </SiteFooterV2Item>
              ))}
            </SiteFooterV2ItemGroup>
          ))}
        </SiteFooterV2Main>
        <Grid isFluid isGutterless>
          <GridRow justify="between" align="center">
            <GridCol m={8} l={8} xl={9}>
              <Text
                size="s"
                tone="supporting"
                elementType="p"
                id="ee-footer-legal-info"
              >
                {socialData?.legalInfo}
              </Text>
            </GridCol>
            <GridCol m={4} l={4} xl={3}>
              <Group>
                {socialLinks.map(({ linkUrl, icon, ariaLabel }) => (
                  <GroupItem key={linkUrl}>
                    <ButtonV2
                      id="social-links"
                      icon={icon}
                      href={linkUrl}
                      buttonStyle="compact"
                      ariaLabel={ariaLabel}
                    />
                  </GroupItem>
                ))}
              </Group>
            </GridCol>
          </GridRow>
        </Grid>
        <VerticalSpace size="24" />
      </SiteFooterV2>
      <div className="ee-footer-utility">
        <SiteFooterV2Utility
          contentSlot={
            <Text size="m">
              <span className="arc-SiteFooterV2-copyrightSymbol">©</span>{' '}
              {copyrightNotice?.toUpperCase()}
            </Text>
          }
        >
          {infoLinks?.map((item) => (
            <SiteFooterV2Item key={item.title} href={item.linkUrl}>
              <Text size="m" id="ee-footer-utility-item">
                {item.title}
              </Text>
            </SiteFooterV2Item>
          ))}
        </SiteFooterV2Utility>
      </div>
    </>
  );
};

export default EEBFooterDesktop;
